import { render, staticRenderFns } from "./CustomResourceDefinitionPropertyPanel.vue?vue&type=template&id=fcc93b26&"
import script from "./CustomResourceDefinitionPropertyPanel.vue?vue&type=script&lang=js&"
export * from "./CustomResourceDefinitionPropertyPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VListItemTitle,VTextField})
